module.exports = "/static/img/where_02.png?a3a1b5aea16847b93ac7df53dc98ab75";